import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import SearchOverlay from 'components/SearchOverlay';
import WelcomeMessage from 'components/Dashboard/WelcomeMessage';
import RecentItems from 'components/Dashboard/RecentItems';
import ToolsGrid from 'components/Dashboard/ToolsGrid';
import MobileHeader from 'components/MobileHeader';

export default function Dashboard() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                setSearch={setSearch}
                search={search}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>

                <div className='h-[100svh] overflow-y-auto'>
                    <div className='max-w-5xl mx-auto px-4 md:px-6 pt-20 pb-10'>
                        <WelcomeMessage />
                        <RecentItems />
                        <ToolsGrid />
                    </div>
                </div>
            </div>
        </>
    )
}
